/**
 * Fetch with AbortController timeout — avoids indefinite admin dashboard hangs.
 */
export async function fetchWithTimeout(url, options = {}, timeoutMs = 60_000) {
  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), timeoutMs);

  try {
    return await fetch(url, { ...options, signal: controller.signal });
  } catch (err) {
    if (err?.name === 'AbortError') {
      const timeoutErr = new Error('Request timed out. Try Refresh.');
      timeoutErr.status = 408;
      throw timeoutErr;
    }
    throw err;
  } finally {
    window.clearTimeout(timer);
  }
}
